import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Table, Select, message } from "antd";
import { useSelector } from "react-redux";
import { fetchTAT } from "./FetchTAT";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_tat, update_tat } from "../../endpoints/API";

const TAT = () => {
  const isUser = useSelector((state) => state.user.user);
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [TAT, setTAT] = useState([]); // State to store cities data
  const [form] = Form.useForm(); // Ant Design form instance
  const [editingRecord, setEditingRecord] = useState(null); // State to track editing record

  useEffect(() => {
    const getTAT = async () => {
      try {
        await fetchTAT(setTAT, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch TAT(Turn Around Time).");
      }
    };

    getTAT();
  }, []);

  const showModal = () => {
    setEditingRecord(null); // Reset editing record for new entry
    form.resetFields(); // Reset form fields
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = async (values) => {
    if (editingRecord) {
      // Update existing record
      const payload = {
        ...editingRecord,
        ...values,
      };

      try {
        const response = await update_tat(editingRecord.id, payload);

        if (response.statusText == "OK") {
          const result = response?.data;
          setTAT((prevTAT) =>
            prevTAT.map((item) =>
              item.id === editingRecord.id ? result.data : item
            )
          );
          setIsModalOpen(false);
        } else {
          console.error("Failed to update TAT");
        }
      } catch (error) {
        message.error(error?.response?.data?.error);
      }
    } else {
      // Create new record
      const payload = {
        ...values,
        created_by: isUser.user_id,
      };

      try {
        const response = await create_tat(payload);

        if (response.statusText=="OK") {
          const result = response?.data;
          setTAT((prevTAT) => [...prevTAT, result.data]);
          setIsModalOpen(false);
        } else {
          console.error("Failed to create TAT");
        }
      } catch (error) {
        message.error(error?.response?.data?.error);
      }
    }
  };

  const handleEdit = (record) => {
    setEditingRecord(record); // Set the record to be edited
    form.setFieldsValue(record); // Populate the form with record data
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Pickup Minutes",
      dataIndex: "tat_pickup_time",
      key: "tat_pickup_time",
    },
    {
      title: "Duration Unit",
      dataIndex: "duration_unit",
      key: "duration_unit",
      render: (text) => (text === "min" ? "Minutes" : "Hours"),
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div style={{ position: "relative", padding: 20 }}>
      {/* Button to open modal */}
      <Button
        type="primary"
        style={{ position: "absolute", top: 10, right: 10 }}
        onClick={showModal}
      >
        Create TAT
      </Button>

      {/* Modal with Form */}
      <Modal
        title={
          editingRecord
            ? "Edit Turn Around Time (TAT)"
            : "Create Turn Around Time (TAT)"
        }
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form layout="vertical" onFinish={handleFormSubmit} form={form}>
          <Form.Item
            label="Pickup Minutes"
            name="tat_pickup_time"
            rules={[{ required: true, message: "Please enter pickup minutes" }]}
          >
            <Input type="number" placeholder="Enter pickup minutes" />
          </Form.Item>

          <Form.Item
            label="Duration"
            name="duration_unit"
            rules={[{ required: true, message: "Please select duration" }]}
          >
            <Select
              placeholder="Select duration"
              options={[
                { label: "Minute", value: "min" },
                { label: "Hour", value: "hour" },
              ]}
            />
          </Form.Item>

          <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button onClick={handleCancel} className="ml-[.5rem]">
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Table displaying TAT data */}
      <Table
        columns={columns}
        dataSource={TAT}
        rowKey={(record) => record.id}
        style={{ marginTop: 50 }}
      />
    </div>
  );
};

export default TAT;
